

















































import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import SelectionFieldText from './SelectionFieldText.vue';
import SelectionFieldAction from './SelectionFieldAction.vue';

type FilterFunctionType = (item: object, queryText: string, itemText: string) => boolean;

@Component({ components: { SelectionFieldText, SelectionFieldAction } })
export default class SelectionField<T extends any> extends Vue {
  searchQuery = '';

  @Prop([Boolean, Object, String, Array, Number])
  value!: T;
  @Prop({ default: 'keyboard_arrow_down', type: String })
  iconName!: string;
  @Prop(Array)
  items!: T[];
  @Prop(Boolean)
  isItemsPartial!: boolean;
  @Prop(String)
  placeholder!: string;
  @Prop(Boolean)
  disabled!: boolean;
  @Prop(Boolean)
  clearable!: boolean;
  @Prop(Boolean)
  multiple!: boolean;
  @Prop({ type: String, default: 'text' })
  itemText!: string;
  @Prop({ type: String })
  itemSubText!: string;
  @Prop({ type: String, default: 'id' })
  itemValue!: string;
  @Prop({ type: Boolean, default: false })
  dropdown!: boolean;
  @Prop({ type: Boolean, default: false }) hasAction!: boolean;
  @Prop({ type: String, default: 'info' }) actionIcon!: string;
  @Prop(Boolean) hasError!: boolean;
  @Prop(Function) filter!: FilterFunctionType;

  @Emit()
  action(item: T) {
    return item;
  }

  get _items(): T[] {
    let items: T[] = [];

    if (this.items && this.items.length > 0) {
      items = this.items.slice();
    }

    if (this.isItemsPartial && this.value) {
      items.push(this.value);
    }

    return items;
  }

  get label() {
    if (Array.isArray(this.value)) {
      return this.value.map((item: any) => item[this.itemText]).join(', ');
    }
    // @ts-ignore
    return this.value[this.itemText] + (this.value[this.itemSubText] ? ' (' + this.value[this.itemSubText] + ')' : '');
  }

  @Watch('searchQuery')
  search(searchQuery: string) {
    if (searchQuery) {
      this.$emit('search', searchQuery);
    }
  }

  valueChanged(value: any) {
    value = value ? value : null;
    this.$emit('change', value);
  }

  clear() {
    (this.$refs.autocomplete as any).clearableCallback();
  }
}
